import React, {useState, useEffect, useRef} from 'react';

interface SearchInputProps {
  placeholder?: string;
  onSearch: (value: string) => void;
  debounceMs?: number;
  searchValue?: string | null;
}

export const SearchInput: React.FC<SearchInputProps> = ({
  placeholder = 'Search...',
  onSearch,
  debounceMs = 500,
  searchValue,
}) => {
  const [value, setValue] = useState<string>(searchValue || '');
  const lastSearchedValue = useRef<string>('');

  // Keep the latest onSearch in a ref so an unstable callback prop (a new
  // function each render) can't re-trigger the debounce effect and loop.
  const onSearchRef = useRef(onSearch);
  useEffect(() => {
    onSearchRef.current = onSearch;
  }, [onSearch]);

  useEffect(() => {
    const trimmedValue = value.trim();

    const timer = setTimeout(() => {
      onSearchRef.current(trimmedValue);
      lastSearchedValue.current = trimmedValue;
    }, debounceMs);

    return () => clearTimeout(timer);
  }, [value, debounceMs]);

  return (
    <div style={{width: '100%', maxWidth: '600px'}}>
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={e => setValue(e.target.value)}
        style={{
          width: '100%',
          padding: '18px 25px',
          borderRadius: '12px',
          border: 'none',
          backgroundColor: '#333',
          color: '#fff',
          fontSize: '1.1rem',
          outline: 'none',
          boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
          boxSizing: 'border-box',
        }}
      />
    </div>
  );
};
